// ToastContext.js
import React, { createContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useMediaQuery } from 'react-responsive';

// COMPONENTS
import Toast from 'components/toastComponent';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const isMobile = useMediaQuery({ maxWidth: 640 });

    const addToast = (title, message, action, actionText, type) => {
        const id = uuidv4();
        setToasts((prevToasts) => {
            // Limiter à 5 toasts maximum
            const maxToasts = 5;
            const newToasts = prevToasts.length >= maxToasts 
                ? [...prevToasts.slice(1), { title, message, action, actionText, type, id }]
                : [...prevToasts, { title, message, action, actionText, type, id }];
            return newToasts;
        });
    };

    const removeToast = (id) => {
        setToasts((prevToasts) =>
            prevToasts.filter((toast) => toast.id !== id)
        );
    };

    return (
        <ToastContext.Provider value={{ addToast }}>
        {children}
        <div className={`
            fixed 
            ${isMobile ? 'top-0 left-0 right-0' : 'bottom-5 right-5'} 
            flex flex-col 
            ${isMobile ? 'gap-2' : 'gap-3'} 
            z-[9999]
            ${isMobile ? 'p-0' : 'max-w-[520px]'}
        `}>
            {toasts.map((toast, index) => (
                <Toast
                    key={toast.id}
                    title={toast.title}
                    message={toast.message}
                    action={toast.action}
                    actionText={toast.actionText}
                    type={toast.type}
                    onClose={() => removeToast(toast.id)}
                    index={index}
                    total={toasts.length}
                />
            ))}
        </div>
        </ToastContext.Provider>
    );
};